var map = {
	"./cosa-e-un-erp.png": "./app/javascript/assets/images/bulloni_digitali/cosa-e-un-erp.png",
	"./gigi.jpeg": "./app/javascript/assets/images/bulloni_digitali/gigi.jpeg",
	"./le-api.png": "./app/javascript/assets/images/bulloni_digitali/le-api.png",
	"./mario.jpg": "./app/javascript/assets/images/bulloni_digitali/mario.jpg",
	"./paolina.jpg": "./app/javascript/assets/images/bulloni_digitali/paolina.jpg",
	"./scambio-file.png": "./app/javascript/assets/images/bulloni_digitali/scambio-file.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/assets/images/bulloni_digitali sync recursive \\.jpg$|\\.png$|\\.jpeg$";